module.exports = __webpack_public_path__ + "static/media/dunajska2.6492dc0e.jpg";